import { useEffect, useRef } from "react";
import { adminDestination, readLaunchRoute } from "../../common/deepLinks";
import { currentTenantCode, setActiveTenantCode } from "./api";

export const launch = readLaunchRoute();
if (launch.value) setActiveTenantCode(launch.value.tenant);

export function useDeepLink(options: {
  ready: boolean; tenant?: string; isAdmin?: boolean;
  openOrder: (value: string) => Promise<void>;
  navigate: (view: "home" | "orders" | "billing") => void;
  error: (message: string) => void;
}) {
  const consumed = useRef(false);
  useEffect(() => {
    if (!options.ready || consumed.current) return;
    consumed.current = true;
    if (launch.error) { options.error(launch.error); return; }
    const target = launch.value;
    if (!target) return;
    if (options.tenant !== target.tenant || currentTenantCode() !== target.tenant) {
      options.error("Нет доступа к клиенту из ссылки"); return;
    }
    if (target.route.startsWith("admin_")) {
      if (!options.isAdmin) { options.error("Этот раздел доступен только администратору"); return; }
      window.location.assign(adminDestination(target));
    } else if (target.route === "order" || target.route === "return" || (target.route === "support" && target.reference)) {
      void options.openOrder(target.reference);
    } else {
      options.navigate(target.route === "billing" ? "billing" : target.route === "orders" ? "orders" : "home");
    }
  }, [options.ready, options.tenant]);
}
